import { normalizeInterveneMessage } from './normalizeInterveneMessage';

export const PREVIEW_LABELS = {
  text: null,
  buttons: '[Interactive buttons]',
  list: '[List message]',
  template: '[Template]',
  image: '[Image]',
  video: '[Video]',
  audio: '[Audio]',
  document: '[Attachment]',
  reply: '[Reply]',
  order: '[Order]',
  catalog: '[Catalog]',
  location: '[Location]',
  payment: '[Payment]',
  flow: '[Flow]',
  nfm_reply: '[Form reply]',
  ctaurl: '[Link message]',
  openai: '[AI message]',
  intervention: '[Intervention]',
  orderstatus: '[Order status]',
  address: '[Address]',
};

export function formatRelativeTime(dateStr) {
  if (!dateStr) return '';
  try {
    const diff = Date.now() - new Date(dateStr).getTime();
    const mins = Math.floor(diff / 60000);
    if (mins < 1) return 'now';
    if (mins < 60) return `${mins}m`;
    const hrs = Math.floor(mins / 60);
    if (hrs < 24) return `${hrs}h`;
    return `${Math.floor(hrs / 24)}d`;
  } catch {
    return '';
  }
}

export function getUserInitial(name) {
  if (!name) return '?';
  return name.charAt(0).toUpperCase();
}

export function getMessagePreview(message) {
  if (!message) return 'No recent messages';

  const normalized = normalizeInterveneMessage(message);
  const previewText =
    normalized.text ||
    normalized.template?.body ||
    normalized.reply?.text ||
    normalized.media?.caption ||
    normalized.card?.body;

  if (previewText) return previewText;

  return PREVIEW_LABELS[normalized.kind] || 'No recent messages';
}
